import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getHierarchies = async () => {
  return axios.get(`${api_base_url}/Hierarchy`).then((res) => {
    return res.data;
  });
};

export const getHierarchyById = async (hierarchyId) => {
  return axios.get(`${api_base_url}/Hierarchy/${hierarchyId}`).then((res) => {
    return res.data;
  });
};

export const getParentHierarchyById = async (hierarchyId, isParent = false) => {
  return axios
    .get(
      `${api_base_url}/Hierarchy/GetParentHierarchyById/${hierarchyId}/${isParent}`
    )
    .then((res) => {
      return res.data;
    });
};

export const getHierarchyTypes = async () => {
  return axios.get(`${api_base_url}/Hierarchy/HierarchyType`).then((res) => {
    return res.data;
  });
};

export const addHierarchy = async (newHierarchy) => {
  return await axios.post(`${api_base_url}/Hierarchy`, {
    ...newHierarchy,
  });
};

export const updateHierarchy = async (updateHierarchy) => {
  const formData = new FormData();

  for (const properties in updateHierarchy) {
    if (
      updateHierarchy[properties] !== null &&
      updateHierarchy[properties] !== undefined
    ) {
      formData.append(`${properties}`, updateHierarchy[properties]);
    }
  }

  return await axios.put(`${api_base_url}/Hierarchy`, formData);
};

export const getHierarchyActivityHistoryById = async (hierarchyId) => {
  return axios
    .get(
      `${api_base_url}/Hierarchy/HierarchyActivityHistoryById/${hierarchyId}`
    )
    .then((res) => {
      return res.data;
    });
};

export const getAssociatedHierarchyById = async (hierarchyId) => {
  return axios
    .get(`${api_base_url}/Hierarchy/AssociatedHierarchyById/${hierarchyId}`)
    .then((res) => {
      return res.data;
    });
};

export const deactivateHierarchy = async (hierarchyIds) => {
  return await axios.delete(`${api_base_url}/Hierarchy`, {
    data: hierarchyIds,
  });
};

export const getHierarchyOrgChart = async () => {
  return axios
    .get(`${api_base_url}/Hierarchy/HierarchyOrgChart`)
    .then((res) => {
      return res.data;
    });
};

export const getFilteredHierarchies = async (searchInputsData) => {
  const [, filters] = searchInputsData.queryKey;
  var queryStrings = new URLSearchParams();

  if (filters) {
    const keys = [
      "hierarchyName",
      "hierarchyTypeName",
      "hierarchyId",
      "hierarchyTypeId",
    ];
    keys.forEach((key) => {
      const value = filters[key as keyof typeof filters];
      if (value) {
        queryStrings.append(key.charAt(0).toUpperCase() + key.slice(1), value);
      }
    });
  }
  var filterParams = {
    params: queryStrings,
  };

  return axios
    .get(`${api_base_url}/Hierarchy/FilteredHierarchies`, filterParams)
    .then((res) => {
      return res.data;
    });
};

export const sendHierarchyEmail = async (data) => {
  return axios
    .post(`${api_base_url}/email/SendHierarchyEmail/`, data)
    .then((res) => {
      return res;
    });
};

export const getHierarchyEmployeeOpts = async () => {
  return axios
    .get(`${api_base_url}/Hierarchy/HierarchyEmployeeOpts`)
    .then((res) => {
      return res.data;
    });
};

export const getHierarchyOpts = async () => {
  const { data } = await axios.get(`${api_base_url}/Hierarchy/HierarchyOpts`);
  return data;
};
